import authRoles from '../../../../../auth/authRoles';

const { everyoneButGuest } = authRoles;

export default [
    {
        id: 'dashboard',
        title: 'Dashboard',
        icon: 'Home',
        path: '/dashboard',
        roles: everyoneButGuest,
        permission: ['GetDashboardDetails'],
    },
    {
        id: 'transport-hauler-management',
        title: 'Hauler Management',
        icon: 'Hauling',
        path: '/hauler-management',
        roles: ['transport'],
        permission: ['AccessHaulerManagement'],
        subPermissionOnly: true,
    },
    {
        id: 'processor-plant-management',
        title: 'Plant Management',
        icon: 'Processor',
        path: '/plant-management',
        roles: ['processor'],
        permission: ['AccessPlantManagement'],
        subPermissionOnly: true,
    },
    {
        id: 'producer-producer-management',
        title: 'Producer Management',
        icon: 'Producer',
        path: '/producer-management',
        roles: ['producer'],
        permission: ['AccessProducerManagement'],
        subPermissionOnly: true,
    },
    {
        id: 'raw-milk-tracking-group',
        title: 'Raw Milk Tracking',
        icon: 'RawMilk',
        type: 'group',
        subPermissionOnly: true,
        requireAllPermissions: false,
        children: [
            {
                id: 'transportation-title',
                type: 'subheader',
                title: 'Transportation',
            },
            {
                id: 'route-sessions',
                title: 'Route Sessions',
                icon: 'RawMilk',
                path: '/route-sessions',
                roles: ['admin', 'processor'],
                permission: ['ListRouteSessions'],
            },
            {
                id: 'pickups',
                title: 'Pickups',
                icon: 'RawMilk',
                path: '/pickups',
                roles: ['admin', 'transport'],
                permission: ['ListPickups'],
            },
            {
                id: 'processor-pickups',
                title: 'Pickups For Processor',
                icon: 'RawMilk',
                path: '/pickups-processor',
                roles: ['admin'],
                permission: ['ViewPickupsForProcessor'],
            },
            {
                id: 'dropoffs',
                title: 'Dropoffs',
                icon: 'RawMilk',
                path: '/dropoffs',
                roles: ['admin', 'transport', 'processor'],
                permission: ['ListDropoffs'],
            },
            {
                id: 'route-management',
                title: 'Route Management',
                icon: 'Route',
                path: '/list-routes',
                roles: ['admin'],
                permission: ['ListRoutes'],
            },
            {
                id: 'schedule-route-management',
                title: 'Route Management',
                icon: 'Route',
                path: '/list-schedule-routes',
                roles: ['admin', 'transport'],
                permission: ['ListScheduleRoutes'],
            },
            {
                id: 'logistics-title',
                type: 'subheader',
                title: 'Logistics',
            },
            {
                id: 'driver-location',
                title: 'Driver Location',
                icon: 'RawMilk',
                path: '/driver-locations',
                roles: ['admin', 'transport'],
                permission: ['ViewDriverLocations'],
            },
            {
                id: 'delivery-documents',
                title: 'Delivery Documents',
                icon: 'RawMilk',
                path: '/delivery-documents',
                roles: ['admin', 'transport', 'processor'],
                permission: ['ManageRawMilkDeliveryDocuments'],
            },
            {
                id: 'cip-wash',
                title: 'CIP Wash',
                icon: 'RawMilk',
                path: '/washes',
                roles: ['admin'],
                permission: ['ListCIPWash'],
            },
            {
                id: 'transport-cip-wash',
                title: 'CIP Wash',
                icon: 'RawMilk',
                path: '/washes',
                roles: ['transport'],
                permission: ['ListCIPWash'],
                subPermissionOnly: true,
            },
        ],
    },
    {
        id: 'quality-group',
        title: 'Quality',
        icon: 'Quality',
        type: 'group',
        requireAllPermissions: false,
        children: [
            {
                id: 'labs-title',
                type: 'subheader',
                title: 'Labs',
            },
            {
                id: 'lab-reports',
                title: 'Lab Reports',
                icon: 'Quality',
                path: '/lab-reports',
                roles: ['admin'],
                permission: ['ListLabReports'],
            },
            {
                id: 'lab-charts',
                title: 'Lab Charts',
                icon: 'Quality',
                path: '/lab-charts',
                roles: ['admin'],
                permission: ['ListLabReports'],
            },
        ],
    },
    {
        id: 'provider-lab-reports',
        title: 'Lab Reports',
        icon: 'Quality',
        roles: ['lab_provider'],
        path: '/lab-reports',
    },
    {
        id: 'memberships-group',
        title: 'Memberships',
        icon: 'Memberships',
        type: 'group',
        requireAllPermissions: false,
        children: [
            {
                id: 'communication-title',
                type: 'subheader',
                title: 'Communication',
            },
            {
                id: 'file-share-received',
                title: 'Received Files',
                icon: 'Files',
                path: '/shared-files/received',
                roles: everyoneButGuest.filter((role) => !['producer', 'processor'].includes(role)),
                permission: ['ListSharedFiles'],
            },
            {
                id: 'file-share-shared',
                title: 'Shared Files',
                icon: 'Files',
                path: '/shared-files/shared',
                roles: ['admin', 'producer_business'],
                permission: ['ListSharedFiles'],
            },
            {
                id: 'documents',
                title: 'Documents',
                icon: 'Files',
                path: '/documentation/tables',
                roles: ['admin'],
                permission: ['ViewDocumentation'],
            },
        ],
    },
    {
        id: 'reports-group',
        title: 'Reports',
        icon: 'Reports',
        type: 'group',
        requireAllPermissions: false,
        children: [
            {
                id: 'monthly-reports',
                title: 'Monthly Reports',
                icon: 'Reports',
                path: '/monthly-reports',
                roles: ['admin'],
                permission: ['ListMonthlyReports'],
                badge: {
                    title: 0,
                    bg: 'rgb(204,121,167)',
                    fg: '#000000',
                },
            },
            {
                id: 'route-stats',
                title: 'Route Reports',
                icon: 'Reports',
                roles: ['admin'],
                path: '/route-stats',
                permission: ['ViewRouteStats'],
            },
            {
                id: 'driver-stats',
                title: 'Driver Reports',
                icon: 'Reports',
                roles: ['admin'],
                path: '/driver-stats',
                permission: ['ViewDriverStats'],
            },
            {
                id: 'general-stats',
                title: 'General Reports',
                icon: 'Reports',
                roles: ['admin'],
                path: '/general-stats',
                permission: ['ViewGeneralStats'],
            },
            {
                id: 'pickup-stats',
                title: 'Pickup Reports',
                icon: 'Reports',
                roles: ['admin'],
                path: '/pickup-stats',
                permission: ['ViewPickupStats'],
            },
            {
                id: 'production-stats',
                title: 'Production Reports',
                icon: 'Reports',
                roles: ['admin'],
                path: '/production-stats',
                permission: ['ViewProductionStats'],
            },
            {
                id: 'hauling-stats',
                title: 'Hauling Reports',
                icon: 'Reports',
                roles: ['admin'],
                path: '/hauling-stats',
                permission: ['ViewHaulingStats'],
            },
            {
                id: 'embedded-reports',
                title: 'Reporting',
                icon: 'Reports',
                path: '/reporting',
                roles: ['admin', 'transport', 'processor', 'lab-provider'],
            },
            {
                id: 'upload-download',
                title: 'Upload/Download',
                icon: 'Files',
                path: '/upload-download',
                roles: ['admin', 'transport', 'processor'],
                permission: ['UploadDownload'],
            },
        ],
    },
    {
        id: 'producer-pickups',
        title: 'Pickups',
        icon: 'RawMilk',
        path: '/pickups',
        roles: ['producer'],
        permission: ['ListPickups'],
    },
    {
        id: 'producer-lab-reports',
        title: 'Lab',
        icon: 'Quality',
        path: '/lab-reports',
        roles: ['producer'],
        permission: ['ListLabReports'],
    },
    {
        id: 'producer-penalty',
        title: 'Penalty Status',
        icon: 'Quality',
        roles: ['producer'],
        path: '/penalty-status',
        permission: ['ListBactoAlert'],
    },
    {
        id: 'producer-reports',
        title: 'Reporting',
        icon: 'Reports',
        path: '/reporting',
        roles: ['producer'],
    },
    {
        id: 'producer-monthly-reports',
        title: 'Monthly Reports',
        icon: 'Reports',
        path: '/monthly-reports',
        roles: ['producer'],
        permission: ['ListMonthlyReports'],
        badge: {
            title: 0,
            bg: 'rgb(204,121,167)',
            fg: '#000000',
        },
    },
    {
        id: 'producer-files',
        title: 'Files',
        icon: 'Files',
        path: '/shared-files/received',
        roles: ['producer', 'processor'],
        permission: ['ListSharedFiles'],
        badge: {
            title: 0,
            bg: 'rgb(238,119,51)',
            fg: '#000000',
        },
    },
    {
        id: 'producer-upload-download',
        title: 'Upload/Download',
        icon: 'Files',
        path: '/upload-download',
        roles: ['producer'],
        permission: ['UploadDownload'],
    },
    {
        id: 'divider-1',
        type: 'divider',
    },
    {
        id: 'producer-sub-users',
        title: 'Sub-Users',
        icon: 'UsersAndAssets',
        path: '/manage/sub-users',
        roles: ['producer'],
        permission: ['ListSubProducers'],
    },
    {
        id: 'users-and-assets-group',
        title: 'Users and Assets',
        icon: 'UsersAndAssets',
        type: 'group',
        requireAllPermissions: false,
        children: [
            {
                id: 'users-title',
                type: 'subheader',
                title: 'Users',
            },
            {
                id: 'admins',
                title: 'Admins',
                icon: 'Admin',
                path: '/list-admins',
                roles: ['admin'],
                permission: ['ListAdmins'],
            },
            {
                id: 'producers',
                title: 'Producers',
                icon: 'Producer',
                path: '/list-producers',
                roles: ['admin'],
                permission: ['AccessProducerManagement', 'ListProducers'],
                requireAllPermissions: false,
            },
            {
                id: 'processors',
                title: 'Processors',
                icon: 'Processor',
                path: '/list-processors',
                roles: ['admin'],
                permission: ['AccessPlantManagement', 'ListProcessors'],
                requireAllPermissions: false,
            },
            {
                id: 'hauling-companies',
                title: 'Hauling Companies',
                icon: 'Hauling',
                path: '/list-hauling-companies',
                roles: ['admin'],
                permission: ['ListHaulingCompanies', 'AccessHaulerManagement'],
                requireAllPermissions: false,
            },
            {
                id: 'drivers',
                title: 'Drivers',
                icon: 'Driver',
                path: '/list-drivers',
                roles: ['admin', 'transport'],
                permission: ['ListDrivers'],
            },
            {
                id: 'receivers',
                title: 'Receivers',
                icon: 'SubProcessor',
                path: '/list-receivers',
                roles: ['admin'],
            },
            {
                id: 'processor-receivers',
                title: 'Receivers',
                icon: 'SubProcessor',
                path: '/list-receivers',
                roles: ['processor'],
                permission: ['ListReceivers'],
                subPermissionOnly: true,
            },
            {
                id: 'other-users-title',
                type: 'subheader',
                title: 'Other Users',
            },
            {
                id: 'sub-users',
                title: 'Sub-Users',
                icon: 'UsersAndAssets',
                path: '/manage/sub-users',
                roles: ['admin', 'processor', 'transport'],
                permission: ['ListSubAdmins', 'ListSubProducers', 'ListSubProcessors', 'ListSubHauling'],
                requireAllPermissions: false,
            },
            {
                id: 'linked-users',
                title: 'Linked Users',
                icon: 'UsersAndAssets',
                path: '/manage/link-users',
                roles: ['admin'],
                permission: ['UpdateMultisiteAccess'],
            },
            {
                id: 'assets-title',
                type: 'subheader',
                title: 'Assets',
            },
            {
                id: 'trailers',
                title: 'Trailers',
                icon: 'Trailer',
                path: '/list-trailers',
                roles: ['admin'],
                permission: ['ListTrailers'],
            },
            {
                id: 'transport-trailers',
                title: 'Trailers',
                icon: 'Trailer',
                path: '/list-trailers',
                roles: ['transport'],
                permission: ['ListTrailers'],
                subPermissionOnly: true,
            },
            {
                id: 'wash-facilities',
                title: 'Wash Facilities',
                icon: 'Processor',
                path: '/wash-facilities',
                roles: ['admin'],
                permission: ['ListCIPWash'],
            },
            {
                id: 'other-title',
                type: 'subheader',
                title: 'Other',
            },
            {
                id: 'session-recording',
                title: 'Session Recording',
                icon: 'UsersAndAssets',
                path: '/session-recording',
                roles: ['admin'],
                permission: ['IsSuperUser'],
            },
        ],
    },
    {
        id: 'logout',
        title: 'Logout',
        icon: 'Logout',
        path: '/logout',
    },
];
